export const accountTypeOf = (sub) => ["pilot", "real"].includes(sub?.accountType)
  ? sub.accountType : sub?.status === "pilot" ? "pilot" : "real";

export function accountAccess(sub, now = Date.now()) {
  if (!sub) return { allowed: false, status: "none", accountType: "real" };
  const accountType = accountTypeOf(sub);
  if (accountType === "pilot") return { allowed: true, status: "pilot", accountType };
  let status = sub.status || "none";
  const end = sub.trialEndsAt ? new Date(sub.trialEndsAt).getTime() : NaN;
  if (status === "trialing" && !(Number.isFinite(end) && end > now)) status = "expired";
  const allowed = status === "trialing" || status === "active" ||
    (status === "canceled" && !!sub.currentPeriodEnd && new Date(sub.currentPeriodEnd).getTime() > now);
  return { allowed, status, accountType };
}
